import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() filterParams: any = {};
  @Input() placeholder: string = 'Search';
  @Input() searchParam: string = 'search';
  searchKeyword: string = '';
  private searchInput$ = new BehaviorSubject<string>('');

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.searchInput$
      .pipe(debounceTime(1000), distinctUntilChanged(), untilDestroyed(this))
      .subscribe((value: string) => {
        this.filterParams['page'] = 1;
        if (value.length > 1 || value.length === 0) {
          if (value) {
            this.filterParams[this.searchParam] = value;
          } else {
            delete this.filterParams[this.searchParam];
          }
          this.router.navigate([], { queryParams: this.filterParams });
        }
      });
  }

  onSearchInput(): void {
    this.searchInput$.next(this.searchKeyword);
  }
}
